import {useState, useEffect, useCallback} from 'react'
import {useIsMounted} from '../../hooks'

import {formatMinutes} from '../../utils'

import Slider from '@mui/material/Slider'




const TrackSlider = (props) => {
  const isMounted = useIsMounted()

  const [trackDuration, setTrackDuration] = useState(0)
  const [trackPosition, setTrackPosition] = useState(0)

  const {trackId, audioRef, railColor, trackColor, thumbColor} = props


  useEffect(() => {
    const audio = audioRef.current
    if (!audio) return

    const handleLoadedMetadata = () => {
      if (audio && isMounted.current) {
        setTrackDuration(audio.duration)
      }
    }

    const handleTimeUpdate = () => {
      if (audio && isMounted.current) {
        setTrackPosition(audio.currentTime)
      }
    }

    // Attach event listeners
    audio.addEventListener('loadedmetadata', handleLoadedMetadata)
    audio.addEventListener('timeupdate', handleTimeUpdate)

    // Set initial state in case metadata is already loaded
    if (audio.readyState > 0) {
      setTrackDuration(audio.duration)
      setTrackPosition(audio.currentTime)
    }

    // Cleanup listeners on unmount or when dependencies change
    return () => {
      audio.removeEventListener('loadedmetadata', handleLoadedMetadata)
      audio.removeEventListener('timeupdate', handleTimeUpdate)
    }
  }, [trackId, audioRef, isMounted])



  const setNewPosition = useCallback((e, value) => {
    if (isMounted.current && audioRef.current) {
      setTrackPosition(value)
      audioRef.current.currentTime = value
    }
  }, [audioRef, isMounted])



  return (
    <div data-draggable='false'>
      <Slider
        max={trackDuration}
        min={0}
        value={trackPosition}
        onChange={setNewPosition}
        aria-labelledby='track-position-slider'
        sx={{
          '& .MuiSlider-thumb': {
            backgroundColor: thumbColor || '#000',
          },
          '& .MuiSlider-track': {
            backgroundColor: trackColor || '#000',
          },
          '& .MuiSlider-rail': {
            backgroundColor: railColor || 'lightgrey',
          }
        }}
      />
      <div style={{width: '100%', mt: -0.5, display: 'flex', justifyContent: 'flex-end'}}>
        <p style={{fontSize: '0.9rem'}}>
          {formatMinutes(trackDuration - trackPosition)}
        </p>
      </div>
    </div>
  )
}


export default TrackSlider


